module.exports = __webpack_public_path__ + "fonts/Axiforma-Bold.179a245.ttf";